import { render, staticRenderFns } from "./PlatformPaymentDetailDialog.vue?vue&type=template&id=02dc1198&scoped=true"
import script from "./PlatformPaymentDetailDialog.vue?vue&type=script&lang=js"
export * from "./PlatformPaymentDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./PlatformPaymentDetailDialog.vue?vue&type=style&index=0&id=02dc1198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dc1198",
  null
  
)

export default component.exports